import cx from 'classnames';
import React from 'react';
export const TH = ({ caption, children, className, ...rest }) => (React.createElement("th", { className: cx(className, {
        'tds-th--caption': caption,
    }), ...rest }, children));
